import React from 'react'
import { getShapeBorderStyle, getLineShapeStyle, resolveTextStyle } from '../../lib/global/helpers'

export default function HTMLHeaderTemplate(props) {
    const pageSettings = {
        'a4': {
            'width': 794,
            'height': 1123
        },
        'letter': {
            'width': 595,
            'height': 842
        }
    };

    const renderImage = (section) => {
        const logo = props.properties.head.logo;

        if (!logo.showLogo || !logo.logo) return <></>;

        const logoSize = logo.logoSize || 100;

        const hasExplicitDimensions = logo.style?.width && logo.style?.height;

        const containerStyle = hasExplicitDimensions
            ? { ...logo.style }
            : {
                ...logo.style,
                width: logoSize + "%",
                maxWidth: "100%",
                display: "inline-block",
            };

        return (
            <div
                style={containerStyle}
                key={logo.id || 'logo'}
                data-element={logo.name || 'logo'}
                data-section={section}
                data-path="logo"
                data-index=""
            >
                <div style={{ width: '100%', height: '100%' }}>
                    <img
                        src={props.tempLogo ? props.tempLogo : logo.logo}
                        style={{
                            width: hasExplicitDimensions ? "100%" : logoSize + "%",
                            height: hasExplicitDimensions ? "100%" : "auto",
                            objectFit: "fill",
                            pointerEvents: "none",
                            display: "block",
                        }}
                        alt="Company Logo"
                    />
                </div>
            </div>
        );
    };

    const renderUploadedImages = (section) => {
        const images = props.properties?.[section]?.images;
        if (!images) return null;

        return Object.keys(images).map((key) => {
            const data = images[key];
            if (!data || !data.src) return null;

            return (
                <div
                    key={data.id || key}
                    style={data.style}
                    id={data.id}
                    data-element={data.name}
                    data-section={section}
                    data-path="images"
                    data-index={key}
                >
                    <img
                        src={data.src}
                        alt={data.alt || data.name || ''}
                        style={{ width: '100%', height: '100%', display: 'block' }}
                    />
                </div>
            );
        });
    };

    const renderElements = (section) => {
        return (
            props.properties &&
            props.properties[section]?.elements &&
            Object.keys(props.properties[section].elements).map((key) => {
                var data = props.properties[section].elements[key];
                if (!data) return null;

                var dStyle = Object.assign({}, data.style || {});
                dStyle = resolveTextStyle(dStyle, props.properties[section]?.font, props.properties.prop);

                dStyle.left = dStyle.left ? parseInt(dStyle.left) : 0;
                dStyle.top = dStyle.top ? parseInt(dStyle.top) : 0;

                const dataIndex = data.name ? data.name.replace(/\./g, '') : (data.id || `element-${key}`);

                return (
                    <div
                        key={data.id || key}
                        style={dStyle}
                        id={data.id}
                        data-element={data.name || 'element'}
                        data-section={section}
                        data-path="elements"
                        data-index={dataIndex}
                    >
                        {data.text || ''}
                    </div>
                );
            })
        );
    };

    const renderCompanyElements = () => {
        if (!props.properties.head.companyProps) return null;

        return Object.keys(props.properties.head.companyProps).map((key) => {
            var prop = props.properties.head.companyProps[key];
            if (!prop || !prop.show) return null;

            var dStyle = Object.assign({}, prop.style || {});
            dStyle = resolveTextStyle(dStyle, props.properties.head?.font, props.properties.prop);
            dStyle.left = dStyle.left ? parseInt(dStyle.left) : 0;
            dStyle.top = dStyle.top ? parseInt(dStyle.top) : 0;

            return (
                <div
                    key={key}
                    style={dStyle}
                    id={prop.id}
                    data-element={prop.name || 'company-prop'}
                    data-section={"head"}
                    data-path="companyProps"
                    data-index={prop.data || key}
                >
                    {prop.text || ''}
                </div>
            );
        });
    };

    const renderDocumentTitle = () => {
        var title = props.properties.head.documentTitle;
        if (!title || !title.show) return null;

        var dStyle = Object.assign({}, title.style || {});
        dStyle = resolveTextStyle(dStyle, props.properties.head?.font, props.properties.prop, { defaultFontSize: "20pt", ignoreSectionColor: true });
        dStyle.left = dStyle.left ? parseInt(dStyle.left) : 0;
        dStyle.top = dStyle.top ? parseInt(dStyle.top) : 0;

        return (
            <div
                style={dStyle}
                key={title.id || 'doc-title'}
                id={title.id}
                data-element={title.name || 'document-title'}
                data-section={"head"}
                data-path="documentTitle"
                data-index={title.title || 'title'}
            >
                {title.title || 'INVOICE'}
            </div>
        );
    };

    const renderShapes = () => {
        if (!props.properties.head.shapes) return null;

        return Object.keys(props.properties.head.shapes)
            .filter(s => s !== 'border')
            .map((key) => {
                var prop = props.properties.head.shapes[key];
                if (!prop) return null;

                var sectionBorder = props.properties.head.shapes.border || {};
                var isLine = prop.name && prop.name.startsWith('line');
                var bgColor = prop.fillColor || sectionBorder.fillColor || '#FFFFFFFF';

                var dStyle = Object.assign(isLine ? {} : { minWidth: '32px', minHeight: '16px' }, prop.style || {});
                if (isLine) {
                    Object.assign(dStyle, getLineShapeStyle(prop, sectionBorder));
                } else {
                    Object.assign(dStyle, getShapeBorderStyle(prop, sectionBorder));
                    dStyle.background = bgColor;
                }
                dStyle.left = dStyle.left ? parseInt(dStyle.left) * 0.75 : 0;
                dStyle.width = dStyle.width ? parseInt(dStyle.width) * 0.75 : 32;
                dStyle.top = dStyle.top ? parseInt(dStyle.top) : 0;

                return (
                    <div
                        key={key}
                        style={dStyle}
                        id={prop.id}
                        data-element={prop.name || 'shape'}
                        data-section={"head"}
                        data-path="shapes"
                        data-index={prop.data || key}
                    />
                );
            });
    };

    return (
        <div style={{
            height: props.properties.prop.orientation === "landscape"
                ? props.heights.head * 0.01 * pageSettings[props.properties.prop.paperSize]?.width
                : props.heights.head * 0.01 * pageSettings[props.properties.prop.paperSize]?.height
        }}>
            <div>
                {renderElements("head")}
                {renderImage("head")}
                {renderDocumentTitle()}
                {renderCompanyElements()}
                {renderShapes()}
                {renderUploadedImages("head")}
            </div>
        </div>
    );
}